module.exports = __webpack_public_path__ + "media/neon_icecream.ef7849c6.mp3";